export default [
    {
      path: '/manage-one-789',
      component: () => import('@/admin/pages/ManageOne789s'),
      name: 'ManageOne789',
    }
]
